// Structured frontend logger — the canonical replacement for `console.*` per
// .claude/rules/logging-discipline.md. Today it forwards to `console` in dev
// and is a no-op in prod; once an observability sink lands, the prod path
// ships JSON to it and the rest of the app keeps the same call site.

type Context = Record<string, unknown> | undefined

function emit(level: "info" | "warning" | "error", event: string, context: Context) {
  if (!import.meta.env.DEV) return
  // This module is the only sanctioned boundary for direct `console.*` use
  // (logging-discipline.md).
  const fn = level === "error" ? console.error : level === "warning" ? console.warn : console.log
  fn(`[${level}] ${event}`, context ?? {})
}

export const logger = {
  info: (event: string, context?: Context) => emit("info", event, context),
  warning: (event: string, context?: Context) => emit("warning", event, context),
  error: (event: string, context?: Context) => emit("error", event, context),
}
